import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';

interface ScheduleSlotButtonProps {
  start: string;
  className?: string;
  dataTestId?: string;
  onClick?: () => void;
}

export function ScheduleSlotButton({
  start,
  className,
  dataTestId = DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_SLOT_BUTTON,
  onClick,
}: ScheduleSlotButtonProps) {
  const slotStyles = cn('py-1.5 xl:py-2 text-sm xl:text-base', className);

  if (!onClick) {
    return (
      <Button asChild variant="secondary" color="primary" className={slotStyles} data-testid={dataTestId}>
        <span>{start}</span>
      </Button>
    );
  }

  return (
    <Button variant="secondary" color="primary" className={slotStyles} data-testid={dataTestId} onClick={onClick}>
      {start}
    </Button>
  );
}
